import styled from 'styled-components';
import { HorizontalGroup } from '@libs/uikit/Components';

export const TopHorizontalGroup = styled(HorizontalGroup)`
    align-items: flex-start;
`;
